import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export async function getUserById(id, callback) {
	firebaseRef.ref('/users/' + id).once('value', (snapshot) => {
		console.log('getUserById snapshot', snapshot.val(), id);

		var user = snapshot.val();

		let firstName = '';
		let lastName = '';
		const fullName = user?.fullName;
		if (fullName) {
			const nameArr = fullName.split(' ');
			if (nameArr.length > 0) {
				firstName = nameArr[0];
				lastName = nameArr.splice(1).join(' ');
			}
		}
		user['firstName'] = firstName;
		user['lastName'] = lastName;

		user['companyName'] =
			user?.projectRoles && Object?.keys(user?.projectRoles)[0];
		user['id'] = id;
		user['userType'] = '';
		callback(user);
	});
}
